// -------------------------------------------------------------
// BUILD A BUNDLE PRODUCT PAGE SELECTION TOOL UI
// qc- --bundle
// -------------------------------------------------------------
let bundleSelectedVariantArray;
let bundleIncludesString = "";
let bundleFinalPrice;
let bundleMasterId = $(".js-bundle-master").data("master-id");

let bundleSelections = (function () {
  selections = [];

  function Item(name, price, count, variant, nameDisplay) {
    this.name = name;
    this.price = price;
    this.count = count;
    this.variant = variant;
    this.nameDisplay = nameDisplay;
  }

  let obj = {};

  // Add to bundle selections
  obj.addItemToBundle = function (name, price, count, variant, nameDisplay) {
    let item = new Item(name, price, count, variant, nameDisplay);
    selections.push(item);
  };

  // Set count from bundle selections
  obj.setCountForItem = function (name, count) {
    for (let i in selections) {
      if (selections[i].name === name) {
        selections[i].count = count;
        break;
      }
    }
  };

  // Remove all items from bundle selections
  obj.removeItemFromBundleAll = function (name) {
    for (let item in selections) {
      if (selections[item].name === name) {
        selections.splice(item, 1);
        break;
      }
    }
  };

  // Clear all bundle selections
  obj.clearBundle = function () {
    selections = [];
  };

  // Count bundle selections
  obj.totalCount = function () {
    let totalCount = 0;
    for (let item in selections) {
      totalCount += selections[item].count;
    }
    return totalCount;
  };

  // Total price of bundle selections
  obj.totalBundle = function () {
    let totalBundle = 0;
    for (let item in selections) {
      totalBundle += selections[item].price * selections[item].count;
    }
    return Number(totalBundle.toFixed(2));
  };

  // List bundle selections
  obj.listBundle = function () {
    let bundleCopy = [];
    for (i in selections) {
      item = selections[i];
      itemCopy = {};
      for (p in item) {
        itemCopy[p] = item[p];
      }
      itemCopy.total = Number(item.price * item.count);
      bundleCopy.push(itemCopy);
    }
    return bundleCopy;
  };

  return obj;
})();

// Add item to bundle selection
$(".bundle-item").click(function (event) {
  event.preventDefault();
  let variant = $(this).data("variant-id");
  let nameDisplay = $(this).data("variant-title-display");
  let name = $(this).data("variant-title");
  let price = Number($(this).data("variant-price"));
  bundleSelections.addItemToBundle(name, price, 1, variant, nameDisplay);
  displayBundleSelections();

  var btnIcon = $(this).find('.bundle-item-btn');
  $(btnIcon).removeClass("icon-plus").addClass("icon-check");

  setTimeout(function () {
    $(btnIcon).removeClass("icon-check");
      setTimeout(function() {
        $(btnIcon).addClass("icon-plus");
    }, 500);
  }, 1000);
});

function displayBundleSelections() {
  let bundleSelectionArray = bundleSelections.listBundle();
  let output = "";
  let bundlePricesArray = [];
  let bundleSelectionsRequired = 4;
  bundleSelectedVariantArray = [];
  bundleIncludesString = "";

  for (let i in bundleSelectionArray) {
    output +=
      "<li class='bundle-selected-item'>" + 
      "<p class='bundle-selected-name'>" + bundleSelectionArray[i].nameDisplay + "</p>" +
      "<p class='bundle-selected-price'> $" + (bundleSelectionArray[i].total / 100).toFixed(2) + "</p>" +
      "<button class='bundle-selected-delete delete-bundle-selection icon-cross' data-name=" + bundleSelectionArray[i].name + "></button>" +
      "</li>";
    bundleIncludesString += bundleSelectionArray[i].nameDisplay + ", ";
    bundlePricesArray.push(bundleSelectionArray[i].total);
    bundleSelectedVariantArray.push({
      id: String(bundleSelectionArray[i].variant),
    });
  }

  bundleFinalPrice = (bundleSelections.totalBundle() / 100).toFixed(2);
  bundleIncludesString = bundleIncludesString.replace(/,\s*$/, "");
  $(".bundle-selected-items").html(output);
  $(".bundle-total").html(bundleFinalPrice);
  $(".bundle-drawer-header > p > span").html(bundleSelections.totalCount());

  // for testing
  // console.log("===============================================");
  // console.log(bundleSelectedVariantArray);
  // console.log(bundleIncludesString);
  // console.log(bundleFinalPrice);
  // console.log(bundleSelections.totalCount());
  // console.log("===============================================");

  // add list of products to add to cart button for google analytics custom event
  $("#bundle-add-checked-btn").attr("data-ga", bundleIncludesString);

  // show and hide add to cart button based on amount of selections
  if (bundleSelections.totalCount() < bundleSelectionsRequired) {
    $("#bundle-add-checked-btn").removeClass("bundle-ready");
    $(".bundle-item").removeClass("bundle-disabled");
  } else {
    $("#bundle-add-checked-btn").addClass("bundle-ready");
    $(".bundle-item").addClass("bundle-disabled");
  };

  if (bundleSelections.totalCount() < 1) {
    $(".bundle-drawer").addClass("bundle-drawer-locked");
  } else {
    $(".bundle-drawer").removeClass("bundle-drawer-locked");
  };
}

// Delete bundle item button
$(".bundle-selected-items").on( "click", ".delete-bundle-selection", function (event) {
  let name = $(this).data("name");
  bundleSelections.removeItemFromBundleAll(name);
  displayBundleSelections();
});

// Bundle click button adds selected items to cart via ajax
$("#bundle-add-checked-btn").click(function (event) {
  event.preventDefault();
  addBundleItems(bundleSelectedVariantArray, bundleIncludesString, bundleFinalPrice);
});

// -------------------------------------------------------------
// ADD SELECTED BUNDLE ITEMS TO CART FROM PRODUCT PAGE VIA AJAX
// -------------------------------------------------------------
function addBundleItems(bundleSelectedVariantArray, bundleIncludesString, bundleFinalPrice) {
  let bundleId = 1;

  // get cart items to check for other bundles
  $.ajax({
    url: "/cart.js",
    dataType: "json",
    cache: false,
    success: function (cart) {
      let items = cart.items;
      let bundleIdInCartArray = [];

      // for each item that has a bundle id property add it to the bundleIdInCartArray
      for (var i = 0; i < items.length; i++) {
        if (items[i].properties != null) {
          if ("bundle" in items[i].properties) {
            // bundle does exist so add to array
            let bundleIdInCart = items[i].properties.bundle;
            bundleIdInCartArray.push(bundleIdInCart);
          }
        }
      }

      // assign a unique bundle id
      let highestBundleIdInCart = Math.max(...bundleIdInCartArray);
      let highNumber = parseInt(highestBundleIdInCart);
      if (highNumber >= 1) {
        bundleId = highestBundleIdInCart + 1;
      }
      let bundleSelectedVariantQtyArray = [];

      // products selected remove duplicates and add line item quantity
      const groupAndAdd = (bundleSelectedVariantArray) => {
        const result = new Map();
        bundleSelectedVariantArray.forEach((el) => {
          let item = result.get(el.id) || {
            id: el.id,
            quantity: 0,
            properties: {
              bundle: bundleId,
            },
          };
          item.quantity++;
          result.set(item.id, item);
        });
        return result;
      };

      // from map to array
      groupAndAdd(bundleSelectedVariantArray).forEach((value) =>
        bundleSelectedVariantQtyArray.push(value)
      );

      // add the master product to our selections array
      bundleSelectedVariantQtyArray.push({
        id: bundleMasterId,
        quantity: 1,
        properties: {
          bundle: bundleId,
          _bun_master_product: "bun_master_product",
          _bun_final_price: bundleFinalPrice,
          Selections: bundleIncludesString,
        },
      });

      // final data for add.js
      let data = {
        items: bundleSelectedVariantQtyArray,
      };

      console.log(":::::: BUNDLE PRODUCTS ADDING TO CART ::::::");
      console.log(data);

      // finally add bundle products to cart
      fetch("/cart/add.js", {
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          setTimeout(function () {
            Shopify.AjaxifyCart.refreshMiniCart();
            bundleSelections.clearBundle();
            displayBundleSelections();
            
            // scroll back to top
            let pageTop = $("#header");
            $("html, body").animate(
              { scrollTop: $(pageTop).offset().top, }, 600,
              function () {
                window.location.pageTop = pageTop;
              }
            );
          }, 400);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });
}

// -------------------------------------------------------------
// BUNDLE CART CONTROL
// -------------------------------------------------------------
// bundle quantity in cart - remove bundle
// remove all items in same bundle by cart line item key
// create an array of all products that have the same bundle id and delete them
// called in  app.js and ajaxify cart
function removeBundleItems(changingBundleId) {
  let sameBundleId = 'li[data-cart-bundle-id="' + changingBundleId + '"]';
  let sameBundleIdArray = [];
  let data = { updates: {} };

  $(sameBundleId).each(function (index) {
    sameBundleIdArray.push($(this).attr("data-item-key-id"));
  });

  for (i = 0; i < sameBundleIdArray.length; i++) {
    data.updates[sameBundleIdArray[i]] = 0;
  }
  
  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: "json",
    success: function () {
      setTimeout(function () {
        Shopify.AjaxifyCart.refreshMiniCart();
      }, 300);
    },
  });
}

// bundle smooth scroll to customizations
$(function () {
  $(".js-bundle-jump").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        600,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });
});